var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.3421 0.1589 13.6002 13.7902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003189;\r\n      }\r\n    "))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -75.75653951997356, -10.995292827416733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1",
    transform: "matrix(1, 0, 0, 1, 431.00373, 316.094243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5653",
    "data-name": "Group 5653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    className: "cls-2",
    d: "M -354.895 -303.53 C -354.895 -303.13 -354.725 -302.75 -354.415 -302.49 L -349.975 -298.05 L -354.345 -293.68 C -354.425 -293.6 -354.505 -293.52 -354.575 -293.44 C -354.925 -293.06 -355.005 -292.51 -354.775 -292.05 C -354.565 -291.54 -354.075 -291.21 -353.525 -291.2 C -353.125 -291.2 -352.745 -291.37 -352.485 -291.68 L -348.035 -296.13 L -346.095 -298.07 L -352.405 -304.38 C -352.485 -304.46 -352.565 -304.54 -352.645 -304.61 C -353.025 -304.96 -353.585 -305.04 -354.045 -304.81 C -354.555 -304.6 -354.885 -304.11 -354.895 -303.56",
    style: {
      fill: "rgb(0, 49, 137)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7022",
    "data-name": "Path 7022",
    className: "cls-2",
    d: "M -341.315 -292.56 C -341.315 -292.96 -341.485 -293.34 -341.795 -293.6 L -346.235 -298.04 C -344.815 -299.46 -344.095 -300.18 -341.865 -302.41 C -341.785 -302.49 -341.705 -302.57 -341.635 -302.65 C -341.285 -303.03 -341.205 -303.58 -341.435 -304.04 C -341.645 -304.55 -342.135 -304.88 -342.685 -304.89 C -343.085 -304.89 -343.465 -304.72 -343.725 -304.41 L -348.175 -299.96 L -350.115 -298.02 L -343.805 -291.71 C -343.725 -291.63 -343.645 -291.55 -343.565 -291.48 C -343.185 -291.13 -342.625 -291.05 -342.165 -291.28 C -341.655 -291.49 -341.325 -291.98 -341.315 -292.53",
    style: {
      fill: "rgb(0, 49, 137)",
      strokeWidth: 0
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose2);
export default __webpack_public_path__ + "static/media/ico-close-2.9e22409be838b6aa903819f8541ebfe5.svg";
export { ForwardRef as ReactComponent };